import React, {useEffect, useState} from 'react';
import {NavLink, Route, Routes, useParams} from "react-router-dom";
import Manbalar from "./Manbalar";
import Istemolchilar from "./Istemolchilar";
import Ste from "./Ste";
import {FileTextOutlined, ClearOutlined, ArrowLeftOutlined} from '@ant-design/icons'
import Maydon from "./Maydon";
function Index(props) {
    const [situation,setSituation] = useState(0)
    const [change,setChange] = useState(0)
    const params = useParams()

    useEffect(()=>{
        const manbalar = localStorage.getItem('sfr-hm-manbalar')?JSON.parse(localStorage.getItem('sfr-hm-manbalar')):[]
        const ist = localStorage.getItem('sfr-hm-istemolchilar')?JSON.parse(localStorage.getItem('sfr-hm-istemolchilar')):[]
        const ste = localStorage.getItem('sfr-hm-ste')?JSON.parse(localStorage.getItem('sfr-hm-ste')):[]
        const season = localStorage.getItem('sfr-hm-season')
        const maydon = localStorage.getItem('sfr-hm-'+season+'-maydon')?Object.keys(JSON.parse(localStorage.getItem('sfr-hm-'+season+'-maydon'))):[]
        if(manbalar.length){setSituation(1)}
        if(ist.length){setSituation(2)}
        if(ste.length){setSituation(3)}
        if(maydon.length){setSituation(4)}
    },[change])
    return (
        <div className="container-fluid">
            <div className="row">
                <div className="col-12">
                    <div className="step-menu">
                        <progress  max="100" value={situation*33.33}></progress>
                        <div className="step-block">
                            <div className={situation>0?"step-box box1 active":"step-box box1"}>
                                <NavLink to="/sfr/gidromodul/new/insert/manbalar" className={params['*']==''?'active':''}>1</NavLink><p>Suv manbalari</p>
                            </div>
                            <div className={situation>1?"step-box box2 active":"step-box box2"}>
                                {
                                    situation>0
                                        ?<NavLink to="/sfr/gidromodul/new/insert/istemolchilar" className={params['*']=='istemolchilar'?'active':''}>2</NavLink>
                                    :<span>2</span>
                                }
                                <p>Istemolchilar</p>
                            </div>
                            <div className={situation>2?"step-box box3 active":"step-box box3"}>
                                {
                                    situation>1
                                        ?<NavLink to="/sfr/gidromodul/new/insert/ste" className={params['*']=='ste'?'active':''}>3</NavLink>
                                    :<span>3</span>
                                }
                                <p style={{width:"150%", marginLeft:"-25%"}}>Sanoat texnik extiyojlar</p>
                            </div>
                            <div className={situation>3?"step-box box4 active":"step-box box4"}>
                                {
                                    situation>2
                                        ?<NavLink to="/sfr/gidromodul/new/insert/maydon" className={params['*']=='maydon'?'active':''}>4</NavLink>
                                    :<span>4</span>
                                }
                                <p>Ekin maydonlari</p>
                            </div>

                        </div>
                    </div>
                </div>
                <div className="col-12">
                    <Routes>
                        <Route path="/manbalar" element={<Manbalar/>} />
                        <Route path="/istemolchilar" element={<Istemolchilar/>} />
                        <Route path="/ste" element={<Ste/>} />
                        <Route path="/maydon" element={<Maydon/>} />
                        <Route path="/" element={<Manbalar/>} />
                    </Routes>
                </div>
                <div className="col-12 mt-3">
                    <div className="row">
                        <div className="col">
                            <NavLink to="/sfr/gidromodul/new" className="max-content d-flex align-items-center btn btn-primary btn-lg">
                                <ArrowLeftOutlined/>&nbsp;&nbsp;Qaytish
                            </NavLink>
                        </div>
                        <div className="col">
                            <button
                                onClick={()=>{
                                    localStorage.removeItem('sfr-hm-ste')
                                    localStorage.removeItem('sfr-hm-veg-ekinlar')
                                    localStorage.removeItem('sfr-hm-noveg-ekinlar')
                                    localStorage.removeItem('sfr-hm-istemolchilar')
                                    localStorage.removeItem('sfr-hm-istemolchilar')
                                    localStorage.removeItem('sfr-hm-season')
                                    localStorage.removeItem('sfr-hm-manbalar')
                                    localStorage.removeItem('sfr-hm-veg-maydon')
                                    localStorage.removeItem('sfr-hm-noveg-maydon')
                                    window.location.href = "/sfr/gidromodul/new"
                                }}
                                className="btn btn-danger btn-lg d-flex align-items-center max-content"
                            >Tozalash va qaytish &nbsp;&nbsp;<ClearOutlined /></button>
                        </div>
                        <div className="col text-end">
                            {
                                situation>3?<button
                                                    onClick={()=>{window.location.href="/sfr/gidromodul/new/reports"}}
                                                    className="btn btn-success btn-lg d-flex align-items-center max-content"
                                    >Xisobotlar <FileTextOutlined /></button>
                                    :null
                            }

                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Index;